import { render, staticRenderFns } from "./BasicForms.vue?vue&type=template&id=715a1058&scoped=true"
import script from "./BasicForms.vue?vue&type=script&lang=js"
export * from "./BasicForms.vue?vue&type=script&lang=js"
import style0 from "./BasicForms.vue?vue&type=style&index=0&id=715a1058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a1058",
  null
  
)

export default component.exports